var exports = {
  "vK": "xa15a2ab7--ad2c39--banner",
  "kL": "xa15a2ab7--ad2c39--container",
  "v": "xa15a2ab7--ad2c39--input-block",
  "GP": "xa15a2ab7--ad2c39--suggestions-block",
  "tx": "xa15a2ab7--ad2c39--suggestion-item",
};

module.exports = exports;
